'use client';

import { useCaptureException } from '@kit/monitoring/hooks';

import { SiteHeader } from '~/(marketing)/_components/site-header';
import { PageErrorTracker } from '~/_components/page-error-tracker';
import { ErrorPageContent } from '~/components/error-page-content';
import { RootProviders } from '~/components/root-providers';

const GlobalErrorPage = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useCaptureException(error);

  return (
    // translate="no": Crash-Recovery-Page nicht vom Browser übersetzen lassen,
    // sonst macht Google Translate denselben removeChild-Trigger erneut scharf.
    <html lang="en" translate="no">
      <body>
        <RootProviders>
          <PageErrorTracker
            errorType="error"
            errorMessage={error.message}
            errorStack={error.stack}
          />
          <GlobalErrorContent reset={reset} />
        </RootProviders>
      </body>
    </html>
  );
};

function GlobalErrorContent({ reset }: { reset: () => void }) {
  return (
    <div className={'marketing-scope flex h-screen flex-1 flex-col'}>
      <SiteHeader />

      <ErrorPageContent
        statusCode={'common:errorPageHeading'}
        heading={'common:genericError'}
        subtitle={'common:genericErrorSubHeading'}
        backLabel={'common:goBack'}
        reset={reset}
      />
    </div>
  );
}

export default GlobalErrorPage;
